// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"7b99e98f","787":"cd96bfea"}[chunkId] + ".chunk.js";
};